import React from 'react'
import RegisterPage from './Register'

const Register = () => (
  <RegisterPage/>
)

export default Register
